import React from "react";

const UserMenu = () => (
  <img src="http://www.fillmurray.com/300/300" alt="" className="avatar"/>
);

export default UserMenu;
